import { Grid, Typography } from '@mui/material';
import { Field, useFormikContext } from 'formik';
import React from 'react';
import HdFormikPasswordField from '../../../../../form/formik/components/password-field/HdFormikPasswordField';
import HdFormikTextField from '../../../../../form/formik/components/text-field/HdFormikTextField';
import { HdCheckbox } from '../../../../../checkbox/HdCheckbox';
import HdFormControl from '../../../../../form/components/form-control/HdFormControl';

export default function Mixpanel({ isEditing }: { isEditing: boolean }) {
  const formikProps = useFormikContext<{
    region: string;
  }>();

  const toggleEURegion = checked => {
    formikProps.setFieldValue('region', checked ? 'eu' : undefined);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='projectId'
              label='Project ID'
              helperText='Specify your project ID.'
              required
              component={HdFormikTextField}
              disabled={isEditing}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='projectToken'
              required
              label='Project Token'
              helperText='Specify your project token.'
              masked={isEditing}
              component={HdFormikPasswordField}
              disabled={isEditing}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='serviceAccountUsername'
              label='Service Account Username'
              helperText='Specify your service account username.'
              required
              component={HdFormikTextField}
            />
          </HdFormControl>
        </Grid>

        <Grid item xs={12} md={6}>
          <HdFormControl>
            <Field
              name='serviceAccountSecret'
              required
              label='Service Account Secret'
              helperText='Specify your service account secret.'
              masked={isEditing}
              component={HdFormikPasswordField}
            />
          </HdFormControl>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        <Grid item xs={6} md={6}>
          <HdFormControl>
            <Field
              name='region'
              component={HdCheckbox}
              onChange={toggleEURegion}
              checked={formikProps.values.region === 'eu'}
              label={
                <Typography variant='body2' className='ml-1 text-medium'>
                  Select if your Mixpanel account is in the EU region.
                </Typography>
              }
              dataId={`mixpanel-target-region`}
            />
          </HdFormControl>
        </Grid>
      </Grid>
    </>
  );
}
